import React from 'react';
import { Modal as AntModal, Checkbox, Button, Alert, Dropdown } from 'antd';
import { AimOutlined } from '@ant-design/icons';
import subsystem from '#/util/subsystem';
import userInfo from '#/util/userInfo';
import { env } from '#/util/env';
import './index.scss';

const { username, account } = userInfo.get();

const BASE_CLASS = 'user-info-pop';
function UserInfo() {
  const debugSystemName = subsystem.getDebugSubsystemNames();
  const quitClick = () => {
    window.location.replace(`${window.location.origin}/login`);
  };

  const onDebug = () => {
    let debugSystems = subsystem.getDebugSubsystem();
    const Modal = window?.adsComponents?.Modal ?? AntModal;
    Modal.confirm({
      className: 'ads-debug-modal',
      icon: null,
      title: '选择要调试的子系统',
      content: (
        <Checkbox.Group
          options={subsystem.get().map((item) => ({ label: item.name, value: item.apiPrefix }))}
          defaultValue={debugSystems}
          onChange={(val) => {
            debugSystems = val;
          }}
        />
      ),
      onOk() {
        subsystem.setDebugSystem(debugSystems);
        window.location.reload();
      },
    });
  };

  const DropdownContent = (
    <div className={`${BASE_CLASS}-wrapper`}>
      <div className="basic-info">
        <p className="username">{username}</p>
        <p className="account">{account}</p>
      </div>
      <div className="debug-wrap hide-on-mobile">
        {env !== 'product' ? (
          <Alert
            message={
              <div>
                {`${env} environment`}
                {env === 'product' ? null : (
                  <AimOutlined onClick={onDebug} style={{ marginLeft: '10px', width: 14, height: 14 }} />
                )}
              </div>
            }
            type="warning"
            className="header-warning"
          />
        ) : null}
        <div className="choose-debug-wrapper" style={{ marginBottom: debugSystemName ? 12 : 0 }}>
          {debugSystemName ? (
            <Alert message={`debugging: ${debugSystemName}`} type="warning" className="header-warning" />
          ) : null}
        </div>
      </div>
      <Button onClick={() => window.router.go('resetPassword')} block className="quit mb12">
        Reset Password
      </Button>
      <Button onClick={quitClick} block className="quit">
        Sign Out
      </Button>
    </div>
  );

  return (
    <Dropdown destroyPopupOnHide overlay={DropdownContent} trigger="hover">
      <div className={`${BASE_CLASS} cp`}>
        <span className="userName">{userInfo.get().account[0].toLocaleUpperCase()}</span>
      </div>
    </Dropdown>
  );
}

export default UserInfo;
